// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"prevention_wrapper__gWTSV","content":"prevention_content__ZVfvH","metrics":"prevention_metrics__YeAPB"};